import IconChevronRight from '@apollo/icons/default/IconChevronRight.svg';
import { Menu, MenuButton, MenuContent, MenuItem } from '@apollo/orbit';
// TODO: Use Orbit imports vs Chakra
// eslint-disable-next-line no-restricted-imports
import { MenuListProps, PlacementWithLogical } from '@chakra-ui/react';
import classnames from 'classnames';
import React, { KeyboardEventHandler, ReactElement, useState } from 'react';

interface SubMenuButtonContentProps {
  className?: string;
  subMenuBtnLabel: React.ReactNode;
}
interface Props extends SubMenuButtonContentProps {
  children: ReactElement<MenuListProps> | Array<ReactElement<MenuListProps>>;
  placement?: PlacementWithLogical;
}

const SubMenuButtonContent = ({
  subMenuBtnLabel,
  toggleMenu,
  closeMenu,
  openMenu,
  isOpen,
  className,
}: SubMenuButtonContentProps & {
  toggleMenu: () => void;
  closeMenu: () => void;
  openMenu: () => void;
  isOpen: boolean;
}) => {
  const handleKeyDown: KeyboardEventHandler<HTMLButtonElement> = ({ key }) => {
    if (!isOpen && key === 'ArrowRight') {
      openMenu();
    }
    if (isOpen && ['ArrowLeft', 'Escape'].includes(key)) {
      closeMenu();
    }
  };

  return (
    <MenuButton
      className={classnames('w-full rounded', className)}
      onClick={toggleMenu}
      role="menuitem"
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <MenuItem
        className="m-0" // offsets for the height of the button
        rightIcon={<IconChevronRight />}
      >
        {subMenuBtnLabel}
      </MenuItem>
    </MenuButton>
  );
};

export const SubMenu = ({
  placement = 'right-start',
  children,
  ...subMenuBtnProps
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeMenu = () => {
    if (isOpen) setIsOpen(false);
  };

  const openMenu = () => {
    if (!isOpen) setIsOpen(true);
  };

  const toggleMenu = () => setIsOpen((prev) => !prev);

  return (
    <Menu
      isLazy
      isOpen={isOpen}
      placement={placement}
      computePositionOnMount
      onClose={closeMenu}
      onOpen={openMenu}
      flip={false}
    >
      <SubMenuButtonContent
        {...{ toggleMenu, openMenu, closeMenu, isOpen }}
        {...subMenuBtnProps}
      />
      <MenuContent>
        {React.Children.map(children, (child) => {
          if (React.isValidElement(child)) {
            return React.cloneElement(child, {
              className: `min-w-60${
                child.props?.className ? ` ${child.props.className}` : ''
              } `,
            });
          }
          return child;
        })}
      </MenuContent>
    </Menu>
  );
};
